import React from 'react';
import { Menu } from 'antd';
import {
  PhoneOutlined,
  DashboardOutlined,
  WifiOutlined,
  TeamOutlined,
  ApartmentOutlined,
  MobileOutlined,
  FileSearchOutlined,
  SyncOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

type SidebarNavProps = {
  isAdmin?: boolean;
};

const SidebarNav = ({ isAdmin = false }: SidebarNavProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { role } = useAuth();

  const hasRole = (...allowedRoles: string[]) => role !== null && allowedRoles.includes(role);

  const selectedKey = location.pathname === '/' ? '/crew-sims' : location.pathname;

  const items: any[] = [
    {
      key: '/crew-sims',
      icon: <PhoneOutlined />,
      label: 'Crew SIMs',
    },
    {
      key: '/vrs-usage',
      icon: <WifiOutlined />,
      label: 'Data SIMs',
    },
    {
      key: '/starlink',
      icon: <GlobalOutlined />,
      label: 'Starlink',
    },
  ];

  // Admin section
  const showAdminSection = hasRole(
    'super_admin',
    'reseller_admin',
    'customer_admin',
    'asset_manager'
  );

  if (showAdminSection) {
    const adminChildren: any[] = [];

    if (hasRole('super_admin', 'reseller_admin')) {
      adminChildren.push({
        key: '/admin/dashboard',
        icon: <DashboardOutlined />,
        label: 'Dashboard',
      });
    }
    if (hasRole('super_admin', 'reseller_admin')) {
      adminChildren.push({
        key: '/admin/sync-history',
        icon: <SyncOutlined />,
        label: 'Sync History',
      });
    }
    if (hasRole('super_admin', 'reseller_admin', 'customer_admin', 'asset_manager')) {
      adminChildren.push({
        key: '/admin/orgs-assets',
        icon: <ApartmentOutlined />,
        label: 'Org & Assets',
      });
    }
    if (hasRole('super_admin', 'reseller_admin', 'customer_admin')) {
      adminChildren.push({
        key: '/admin/users',
        icon: <TeamOutlined />,
        label: 'Users',
      });
    }
    // "New Yacht" (/admin/onboarding) and "Setup Wizard" (/admin/wizard) are
    // both hidden from the menu — the Org & Assets table now provides yacht
    // creation directly. Routes remain in App.tsx for deep links and future
    // revival.
    if (hasRole('super_admin', 'reseller_admin')) {
      adminChildren.push({
        key: '/admin/sims',
        icon: <MobileOutlined />,
        label: 'Inventory',
      });
    }
    if (hasRole('super_admin', 'reseller_admin')) {
      adminChildren.push({
        key: '/admin/audit-log',
        icon: <FileSearchOutlined />,
        label: 'Audit Log',
      });
    }

    if (adminChildren.length > 0) {
      items.push({
        key: 'admin-group',
        label: 'Administration',
        type: 'group',
        children: adminChildren,
      });
    }
  }

  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[selectedKey]}
      items={items}
      onClick={({ key }) => navigate(key)}
    />
  );
};

export default SidebarNav;
